<app-progress-card [module]="module" [hasMenu]="true" [url]="url" [queryParam]="queryParam"></app-progress-card>
